import React, {useState} from 'react'
import './LandingCardBanner.scss'
import {MDBContainer} from "mdbreact";
import {AddWalletData} from "../../Actions";
import {compose} from "redux";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {numberFormat} from "../../util";
import {assetUrl} from "../../serviceApi";
import Skeleton from "react-loading-skeleton";

const info = assetUrl + 'images/info-icon.svg'
const rocket = assetUrl + 'images/Illustration pNG rocket.png'
const cloud = assetUrl + "images/Illustration pNG cloud.png";
const shadow = assetUrl + 'images/Illustration pNG Shadow.png'

const LandingBannerCard = (props) => {

	const [animateRocket, setAnimateRocket] = useState(false);

	const {walletData,loading} = props;

	setTimeout(() => {
		setAnimateRocket(true)
	}, 2000)

	return (
		<div>
			<MDBContainer
				className={"landing-card-component px-4"}>
				<div className={"d-flex justify-content-between align-items-end"}>
					<div className={"py-4"}>

						<p className={"available-amount-label mb-2"}>NET WORTH</p>

						<div className={"d-flex align-items-center"}>
							<p className={"available-amount mb-0"}>
								{
									Object.keys(walletData).length > 0 && !props.loading ?
										numberFormat(walletData.availableNettWorth) : 0
								}
							</p>
							<img src={info} alt={"alt"} className={"ml-1"}
							     onClick={() => props.currentModal("walletData")}
							     style={{width: "16px", height: "16px"}}/>
						</div>

					</div>
					{/*{animateRocket && !props.loading && */}
					<div className={"banner-image "}>
						<img src={rocket} alt={"alt"}
						     className={"banner-image-rocket animate__animated animate__fadeInUp delay-1s"}/>
						<img src={cloud} alt={"alt"}
						     className={"banner-image-cloud animate__animated animate__zoomIn delay-2s"}/>
						<img src={shadow} alt={"alt"}
						     className={"banner-image-shadow animate__animated animate__zoomIn delay-2s"}/>
						{/*<img src={bgassets} alt={"alt"} className={"banner-image-assets animate__animated animate__zoomIn delay-3s"}/>*/}
					</div>
					{/*}*/}
				</div>

			</MDBContainer>

		</div>
	)
}

const mapStateToProps = state => ({
	user_details: state.UserReducer.user_details
});

const mapDispatchToProps = dispatch => ({
	setWalletData: data => dispatch(AddWalletData(data))
})

export default compose(
	withRouter,
	connect(mapStateToProps, mapDispatchToProps)
)(LandingBannerCard)

